/**
 * @generated SignedSource<<e240b5247dec97ca295b6c272b6264d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type CreateRuleInputObject = {
  destinationAccountName?: string | null | undefined;
  destinationBankAccountId?: string | null | undefined;
  destinationFilterBankAccountIds?: ReadonlyArray<string> | null | undefined;
  direction?: string | null | undefined;
  expenseNatureId?: string | null | undefined;
  matchKind?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  regex: string;
  sourceBankAccountIds?: ReadonlyArray<string> | null | undefined;
  stakeholderId?: string | null | undefined;
  stakeholderName?: string | null | undefined;
  targetClassification?: TxnClassificationEnum | null | undefined;
  targetType?: string | null | undefined;
};
export type createRuleDialog_CreateRuleMutation$variables = {
  input: CreateRuleInputObject;
};
export type createRuleDialog_CreateRuleMutation$data = {
  readonly createRule: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
      readonly matchesCount: number;
    } | null | undefined;
  } | null | undefined;
};
export type createRuleDialog_CreateRuleMutation = {
  response: createRuleDialog_CreateRuleMutation$data;
  variables: createRuleDialog_CreateRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchesCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createRuleDialog_CreateRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateRuleMutationPayload",
        "kind": "LinkedField",
        "name": "createRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createRuleDialog_CreateRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateRuleMutationPayload",
        "kind": "LinkedField",
        "name": "createRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a9b1f6945a5cc8428569d6695790191a",
    "id": null,
    "metadata": {},
    "name": "createRuleDialog_CreateRuleMutation",
    "operationKind": "mutation",
    "text": "mutation createRuleDialog_CreateRuleMutation(\n  $input: CreateRuleInputObject!\n) {\n  createRule(input: $input) {\n    rule {\n      id\n      matchesCount\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "527b66fa7844f60b8792616ba2876e74";

export default node;
